<!-- Templete  -->
<template>
  <!-- <draggable
    v-bind="dragOptions"
    :emptyInsertThreshold="500"
    :disabled="!enabled"
    class="list-group"
    ghost-class="ghost"
    @start="dragging = true"
    @end="dragging = false"
  > -->
  <div>
    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
    </transition-group>
    <div class="infinite-list-wrapper AllWebTabInfiniteWrapper" style="overflow:auto">
      <ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="enabled">
        <li class="listItem" v-for="(article,i) in articleList" v-bind:key="i">
          <!-- <WebTabArticleComponent
            v-for="article in filterData(articleList,i)"
            v-bind:key="article.article_no"
            v-bind:articleId="article.article_id"
            v-bind:articleTitle="article.title"
            v-bind:articleNo="article.article_no"
            v-bind:articleMediaName="article.media_name"
            v-bind:articleDate="article.reporting_date"
            v-bind:articleCategory="article.category"
            v-bind:articleMediaType="article.media_type"
            v-bind:articleComment="article.comment"
            v-bind:articleWebUrl="article.webUrl"
          /> -->
          <el-container>
            <div class="articleDiv" id="articleParentDiv">
              <el-row>
                <el-header class="header-article">
                  <el-row class="articleRow">
                    <div class="articleLabel">
                      <el-checkbox class="checkbox-list" name="type" :label="article.article_no" @change="handleSelectionChange($event,article)"></el-checkbox>
                    </div>
                    <div class="articleNews" v-if="article.webUrl != '' && article.webUrl != null">
                      <span class="WebTabArticleTitleText" tabindex="1">
                        <a :href=article.webUrl target="_blank" class="article-top">
                          {{ article.title }}
                        </a>
                      </span>
                    </div>
                    <div class="articleNews" v-else>
                      <span class="article_top WebTabArticleTitleText" tabindex="1">
                        {{ article.title }}
                      </span>
                    </div>
                  </el-row>
                </el-header>
              </el-row>
              <el-row>
                <el-main>
                  <div class="commentRow">
                    <ul class="logoArtInfo">
                      <li class="article-first-child">
                      </li>
                      <li class="article-second-child">
                        <div class="article-list WebTabArticleList">
                          <ul class="articleSpec">
                            <li v-if="article.media_name != '' && article.media_name != null">
                              <span class="articleSpan">{{ article.media_name }}</span>
                            </li>
                            <li v-if="article.reporting_date != '' && article.reporting_date != null">
                              <span class="articleSpan">{{ article.reporting_date }}</span>
                            </li>
                            <li v-if="article.category != '' && article.category != null">
                              <span class="articleSpan">{{ article.category }}</span>
                            </li>
                            <li v-if="article.media_type != '' && article.media_type != null">
                              <span class="articleSpan">{{ article.media_type }}</span>
                            </li>
                            <!-- 2022/09/05 No9 トピックスへの検索語追加  START -->
                            <li v-if="article.search_word != ' ' && article.search_word != ''">
                              <span class="articleSpan">{{ article.search_word }}</span>
                            </li>
                            <!-- 2022/09/05 No9 トピックスへの検索語追加  END -->
                          </ul>
                        </div>
                      </li>
                      <li class="article-third-child">
                        <!-- 2021/02/05 #10496 START -->
                        <!-- <div class="article-right">
                            <ul class="iconUl">
                              <li>
                                <div class="ico_another-tab_up" tabindex="0"></div>
                              </li>
                            </ul>
                          </div> -->
                        <!-- 2021/02/05 #10496 END -->
                      </li>
                    </ul>
                  </div>
                </el-main>
              </el-row>
              <el-divider class="article-main-divider"></el-divider>
              <el-footer>
                <div class="ariticle-bottom">
                  <ul v-if="article.comment != '' && article.comment != null">
                    <li>
                      <div class="message ico_comment_upSmall AllWebTabico_comment_upSmall"></div>
                    </li>
                    <li>
                      <div class="message-text WebTabArticleMessageText" v-html="article.comment"></div>
                    </li>
                  </ul>
                </div>
              </el-footer>
              <el-divider class="article-footer-divider"></el-divider>
            </div>
          </el-container>
        </li>
      </ul>
      <p
        v-if="getIsTopPageInitialLoading || loading"
        class="centeralign_css"
      >表示中...( {{ this.articleList.length + 1 }}件 ～ {{ this.articleList.length + this.getMaxArticleCountPerPage }}件 )</p>
      <!-- 2020/11/26  BT08460_EXTERNAL-1812  START  -->
      <!-- <p v-if="this.getIsTopPageInitialLoading == false && IsNoMore" class="centeralign_css">レコードがありません</p>  -->
      <p v-if="this.getIsTopPageInitialLoading == false && IsNoMore" class="centeralign_css">レコードの最後です</p>
      <!-- 2020/11/26  BT08460_EXTERNAL-1812  END  -->
      <p v-if="this.getIsTopPageInitialLoading == false && (NoDefaultRecord)" class="centeralign_css">ヒット結果は0件です</p> 
    </div>
  </div>
  <!-- </draggable> -->
</template>

<!-- Script  -->
<script>
// import draggable from 'vuedraggable';
// import WebTabArticleComponent from './WebTabArticleComponent.vue';
let newArr = [];
import { mapGetters } from "vuex";
import $ from "jquery";
export default {
    name: "simple",
    display: "Transitions",
    order: 3,
    props: {
      drag: Boolean,
      articleList: Array
    },
    components: {
      // draggable,
      // WebTabArticleComponent,	
    },
  data() {
    return {
      count: 10,
      loading: false,
      IsNoMore: false,
      enabled: false,
      dragging: false,
      userId: '',
      contractId: '',
      theme_browsing: '',
      NoDefaultRecord: false,
    };
  },
  methods: {
    load() {
      this.noMore();
      if (this.loading == false) {
  
        // If already loading it will not run.
        // TOOD: if we retirve all article for the given 
        if(this.getThemeWebCount == 0 || this.articleList.length >= this.getThemeWebCount) 
        {
          // if total themeArticle is zero or if we retrived max article, then we will stop executing.
          // Since we have retirved max article, we are res
          this.count = this.getMaxArticleCountPerPage; // resetting.
        }
        else
        {
          // loading variable is used to show how many record is currently retirving.
          this.setLoading(true);

          if(this.count > this.getThemeWebCount)
          {
            // if the next retriving count is greater then total count, then resettting to max.
            this.count = this.getThemeWebCount; 
            this.setLoading(false,"second if");
          }
          else
          {
            this.count += this.getMaxArticleCountPerPage; 
            var themeValue = this.getSelectedTheme[0].value
            var theme_id = this.getSelectedTheme[0].id
            var startNumCount = this.articleList.length + 1
            var webinputParam;
            if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
            {
              if(themeValue == "Theme")
              {
                webinputParam = {
                  contract_id: this.contractId,
                  data_section: 3,
                  process_date_start: this.getDefaultThemeStartDate,
                  process_date_end: this.getDefaultThemeEndDate,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num: startNumCount,
                  load_num: this.getMaxArticleCountPerPage,
                  theme_id: theme_id
                };
              }
              else if(themeValue == "Theme Group")
              {
                webinputParam = {
                  contract_id: this.contractId,
                  data_section: 3,
                  process_date_start: this.getDefaultThemeStartDate,
                  process_date_end: this.getDefaultThemeEndDate,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num: startNumCount,
                  load_num: this.getMaxArticleCountPerPage,
                  theme_group_id: theme_id
                };
              }
              else if(themeValue == "Topics")
              {
                webinputParam = {
                  contract_id: this.contractId,
                  data_section: 3,
                  process_date_start: this.getDefaultThemeStartDate,
                  process_date_end: this.getDefaultThemeEndDate,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num: startNumCount,
                  load_num: this.getMaxArticleCountPerPage,
                  topics_id: theme_id
                };
              }
              else
              {
                //no action needed
              }

              var existingArticleDetails = [];

              existingArticleDetails = [...existingArticleDetails, webinputParam, this.articleList];
              this.$store
                .dispatch("communication/getWebArticles", existingArticleDetails)
                .then(() => {
                  setTimeout(() => {
                    this.setLoading(false);
                  }, 500);
                }).catch(()=>{
                  setTimeout(() => {
                    this.setLoading(false);
                  }, 500);
                });
            }
            else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
            {
              
              webinputParam = {
                contract_id: this.contractId,
                data_section: 3,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingWebDate,
                sort_title: this.getScrollingWebTitle,
                start_num: startNumCount,
                load_num: this.getMaxArticleCountPerPage
              };

              var existingTodayArticleDetails = [];

              existingTodayArticleDetails = [...existingTodayArticleDetails, webinputParam, this.articleList];

              this.$store
                .dispatch("communication/getWebArticles", existingTodayArticleDetails)
                .then(() => {
                  setTimeout(() => {
                    this.setLoading(false);
                  }, 500);
                }).catch(()=>{
                  setTimeout(() => {
                    this.setLoading(false);
                  }, 500);
                });
            }
            else if(this.getSearchConditionKey == 1)
            {
              if(this.getSearchValue != '')
              {
                webinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: 'SID0002',
                  process_date_from:this.getSearchStartDate,
                  process_date_to:this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  search_title: this.getSearchValue,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num:startNumCount,
                  load_num:this.getMaxArticleCountPerPage
                }
              }
              else if(this.getKeywordValue != '')
              {
                if(this.getMediaValue != '')//if media texbox is not equal to empty
                {
                  webinputParam ={
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 2,
                    display_id: 'SID0002',
                    process_date_from:this.getSearchStartDate,
                    process_date_to:this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    key_word: this.getKeywordValue,
                    media_name: this.getMediaValue,
                    sort_date: this.getScrollingWebDate,
                    sort_title: this.getScrollingWebTitle,
                    start_num:startNumCount,
                    load_num:this.getMaxArticleCountPerPage
                  }
                }
                else
                {
                  webinputParam ={
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 2,
                    display_id: 'SID0002',
                    process_date_from:this.getSearchStartDate,
                    process_date_to:this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    key_word: this.getKeywordValue,
                    sort_date: this.getScrollingWebDate,
                    sort_title: this.getScrollingWebTitle,
                    start_num:startNumCount,
                    load_num:this.getMaxArticleCountPerPage
                  }
                }
              }
              else
              {
                if(this.getMediaValue != '')//if media texbox is not equal to empty
                {
                  webinputParam ={
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 2,
                    display_id: 'SID0002',
                    process_date_from:this.getSearchStartDate,
                    process_date_to:this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    media_name: this.getMediaValue,
                    sort_date: this.getScrollingWebDate,
                    sort_title: this.getScrollingWebTitle,
                    start_num:startNumCount,
                    load_num:this.getMaxArticleCountPerPage
                  }
                }
                else
                {
                  webinputParam ={
                    contract_id: this.contractId,
                    user_id: this.userId,
                    contract_kbn: 2,
                    display_id: 'SID0002',
                    process_date_from:this.getSearchStartDate,
                    process_date_to:this.getSearchEndDate,
                    theme_browsing: this.theme_browsing,
                    sort_date: this.getScrollingWebDate,
                    sort_title: this.getScrollingWebTitle,
                    start_num:startNumCount,
                    load_num:this.getMaxArticleCountPerPage
                  }
                }
              }

              var existingSearchArticle = [];

              existingSearchArticle = [...existingSearchArticle, webinputParam, this.articleList];
              //Api call for sorting the news article(AID0071)
              this.$store.dispatch('communication/getWebArticleUsingSorting', existingSearchArticle)
              .then(() => {
                  setTimeout(() => {
                    this.setLoading(false);
                  }, 500);
                }).catch(()=>{
                  setTimeout(() => {
                    this.setLoading(false);
                  }, 500);
                });
            }
            else if(this.getSearchConditionKey == 2)
            {
              if(this.getKeywordValue != '')
              {
                webinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: 'SID0002',
                  process_date_from:this.getSearchStartDate,
                  process_date_to:this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num:startNumCount,
                  load_num:this.getMaxArticleCountPerPage
                }
              }
              else
              {
                webinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: 'SID0002',
                  process_date_from:this.getSearchStartDate,
                  process_date_to:this.getSearchEndDate,
                  theme_browsing: this.theme_browsing,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num:startNumCount,
                  load_num:this.getMaxArticleCountPerPage
                }
              }

              var existingSearchKeywordArticle = [];

              existingSearchKeywordArticle = [...existingSearchKeywordArticle, webinputParam, this.articleList];
              //Api call for sorting the news article(AID0071)
              this.$store.dispatch('communication/getWebArticleUsingSorting', existingSearchKeywordArticle)
              .then(() => {
                  setTimeout(() => {
                    this.setLoading(false);
                  }, 500);
                }).catch(()=>{
                  setTimeout(() => {
                    this.setLoading(false);
                  }, 500);
                });
            }
            else
            {
              //no action needed
            }
          }
        }
      }
      this.noMore();
    },
    noMore() {    
      if(this.getThemeWebCount == 0)
      {
        this.IsNoMore = false
        this.NoDefaultRecord = true
      }
      else
      {
        this.IsNoMore = this.getThemeWebCount <= this.articleList.length;
        this.NoDefaultRecord = false
      }
      if(this.IsNoMore == true || this.NoDefaultRecord == true){
        // if noMore is true, then we are setting this.loading to false.
        this.loading = false
      }
    },
    setLoading(isLoading){
      this.loading = isLoading;
    },
    filterData: function(articleData, i) {
      return articleData.filter(function(article) {
        return article.article_no == i;
      });
    },
    //method for get the selected article count and set the selected article for batch process
    handleSelectionChange(val,article){
      this.$LogButtonEvent("WebTabArticleComponent","ChangeSelection");
      this.$LogMethodIN("WebTabArticleComponent","handleSelectionChange");
      newArr = this.getWebCsvDetails
      var checkboxValue = this.getWebFirstTabCheckboxValue
      if(val == true){
        ++checkboxValue
        newArr.push(article.article_no);
      }else{
        --checkboxValue;
        Array.prototype.remove = function() {
            var what, a = arguments, L = a.length, ax;
            while (L && this.length) {
                what = a[--L];
                while ((ax = this.indexOf(what)) !== -1) {
                    this.splice(ax, 1);
                }
            }
            return this;
        };
        newArr.remove(article.article_no);
      }
      this.$store.commit("situation/setWebFirstTabCheckboxValue", checkboxValue);
      this.$store.commit('situation/setWebCsvDetails', newArr);
      this.$LogMethodOut("WebTabArticleComponent","handleSelectionChange");
    },
  },
  computed: {
    ...mapGetters("situation",[
                    "getSelectedTheme",
                    "getDefaultThemeStartDate",
                    "getDefaultThemeEndDate",
                    "getThemeWebCount",
                    "getMaxArticleCountPerPage",
                    "getRefreshingArticles",
                    "getScrollingWebTitle",
                    "getScrollingWebDate",
                    "getSearchConditionKey",
                    "getSearchValue",
                    "getKeywordValue",
                    "getIsTopPageInitialLoading",
                    "getMediaValue",
                    "getSearchStartDate",
                    "getSearchEndDate",
                    "getTodayArticleFlag",
                    "getWebSecondTabCheckboxValue", 
                    "getWebSecondTabCsvDetails", 
                    "getWebCsvDetails",
                    "getWebFirstTabCheckboxValue"]),
    ...mapGetters("situation0001", ["getUserId",
                                  "getContractId",
                                  "getThemeBrowsing",
                                  "getDefault_Font_Size"]),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    disabled() {
      return this.loading || this.noMore();
    }
  },
  mounted(){
    //get the user id value from session
    this.userId = this.getUserId;

    //get the contract_id value from session
    this.contractId = this.getContractId;

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing;

    var font_size_flag = this.getDefault_Font_Size;
    if(font_size_flag == 0)
    {
      $(".article-img img").css({
        "width": "calc(80% * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $('.select_custom').css({"width": "64px"});
      $('.commentRow ul').css('margin-left', '65px');
      $('.commentRow .logoArtInfo').css('min-height', '30px');
      $('.strip').addClass('smallStrip');
      $('.strip').removeClass('mediumStrip');
      $('.strip').removeClass('largeStrip');
      $('.el-menu--horizontal>.el-menu-item').css('height', '38px');
      $('.menuParent, .webMenuParent').css('height', '28px');
      $('.toolTipDiv span label').css('line-height', '30px');
      $('.year-arrow').css('line-height', '30px');
      $('.year-arrow').addClass('arrowSortSmall');
      $('.year-arrow').removeClass('arrowSortLarge');
      $('.articleLabel .el-checkbox__inner').addClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', 'calc(8pt * 0.8)');
      $(".toolTipDiv span label").css("font-size", "calc(8pt * 0.8)"); 
      $(".selectList").css("font-size", "calc(8pt * 0.8)"); 
      $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "calc(14px * 0.8)",
        "height": "calc(14px * 0.8)",
      });
      $(".display-size > ul > li > span").css('font-size', 'calc(9.6pt * 0.8)');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").addClass('smallCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").removeClass('largeCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_batch-display_up").css({
        "width": "calc(16.57px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_another-tab_up").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".newsTitle, .webNewsTitle").css("font-size","calc(9.6pt * 0.8)");
      $(".display-size, .menuLable div, .message-text").css("font-size", "6.4pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "8.32pt");
      $(".article-list ul li").css("font-size", "6.4pt");
    }
    else if(font_size_flag == 1)
    {
      $(".article-img img").css({
        "width": "80%",
        "height": "22px",
      });
      $('.select_custom').css({"width": "76px"});
      $('.commentRow ul').css('margin-left', '65px');
      $('.commentRow .logoArtInfo').css('min-height', '32px');
       $('.strip').removeClass('smallStrip');
       $('.strip').removeClass('largeStrip');
       $('.strip').addClass('mediumStrip');
      $('.year-arrow').removeClass('arrowSortSmall');
      $('.year-arrow').removeClass('arrowSortLarge');
      $('.el-menu--horizontal>.el-menu-item').css('height', '38px');
      $('.menuParent, .webMenuParent').css('height', '34px');
      $('.toolTipDiv span label').css('line-height', '36px');
      $('.year-arrow').css('line-height', '36px');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', '8pt');
      $(".toolTipDiv span label").css("font-size", "8pt"); 
      $(".selectList").css("font-size", "8pt"); 
       $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "14px",
        "height": "14px",
      });
      $(".display-size > ul > li > span").css('font-size', '9.6pt');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('largeCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('smallCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "22px",
        "height": "22px",
      });
      // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
       "width": "22px",
        "height": "22px",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "22px",
        "height": "22px",
      });
      $(".ico_batch-display_up").css({
        "width": "16.57px",
        "height": "22px",
      });
      $(".ico_another-tab_up").css({
        "width": "22px",
        "height": "22px",
      });
      $(".newsTitle, .webNewsTitle").css("font-size", "9.6pt");
      $(".display-size, .menuLable div, .message-text, .DisplaySize").css("font-size", "8pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "10.4pt");
      $(".article-list ul li").css("font-size", "8pt");
    }
    else
    {
      $(".article-img img").css({
        "width": "calc(80% * 1.5)",
        "height": "calc(22px * 1.5)",
      }); 
      $('.articleLabel').css({
        "width": "85px",
        "display": "inline-table"
      });
      $('.select_custom').css({"width": "108px"});
      $('.ariticle-bottom ul').css('margin-left', '67px');
      $('.commentRow ul').css('margin-left', '85px');
      $('.commentRow .logoArtInfo').css('min-height', '38px');
      $('.strip').addClass('largeStrip');
      $('.strip').removeClass('mediumStrip');
      $('.strip').removeClass('smallStrip');
      $('.year-arrow').removeClass('arrowSortSmall');
      $('.year-arrow').addClass('arrowSortLarge');
      $('.el-menu--horizontal>.el-menu-item').css('height', '45px');
      $('.menuParent, .webMenuParent').css('height', '46px');
      $('.toolTipDiv span label').css('line-height', '47px');
      $('.year-arrow').css('line-height', '54px');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').addClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', 'calc(8pt * 1.5)');
      $(".toolTipDiv span label").css("font-size", "calc(8pt * 1.5)"); 
      $(".selectList").css("font-size", "calc(8pt * 1.5)"); 
       $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "calc(14px * 1.5)",
        "height": "calc(14px * 1.5)",
      });
      $(".display-size > ul > li > span").css('font-size', 'calc(9.6pt * 1.5)');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").addClass('largeCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('smallCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
       // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_batch-display_up").css({
        "width": "calc(16.57px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_another-tab_up").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".newsTitle, .webNewsTitle").css("font-size","calc(9.6pt * 1.5)");
      $(".display-size, .menuLable div, .message-text").css("font-size", "12pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "15.6pt");
      $(".article-list ul li").css("font-size", "12pt");
    }
  },
  updated(){
    var font_size_flag = this.getDefault_Font_Size;
    if(font_size_flag == 0)
    {
      $(".article-img img").css({
        "width": "calc(80% * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $('.select_custom').css({"width": "64px"});
      $('.commentRow ul').css('margin-left', '65px');
      $('.commentRow .logoArtInfo').css('min-height', '30px');
      $('.strip').addClass('smallStrip');
      $('.strip').removeClass('mediumStrip');
      $('.strip').removeClass('largeStrip');
      $('.el-menu--horizontal>.el-menu-item').css('height', '38px');
      $('.menuParent, .webMenuParent').css('height', '28px');
      $('.toolTipDiv span label').css('line-height', '30px');
      $('.year-arrow').css('line-height', '30px');
      $('.year-arrow').addClass('arrowSortSmall');
      $('.year-arrow').removeClass('arrowSortLarge');
      $('.articleLabel .el-checkbox__inner').addClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', 'calc(8pt * 0.8)');
      $(".toolTipDiv span label").css("font-size", "calc(8pt * 0.8)"); 
      $(".selectList").css("font-size", "calc(8pt * 0.8)"); 
      $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "calc(14px * 0.8)",
        "height": "calc(14px * 0.8)",
      });
      $(".display-size > ul > li > span").css('font-size', 'calc(9.6pt * 0.8)');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").addClass('smallCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").removeClass('largeCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_batch-display_up").css({
        "width": "calc(16.57px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".ico_another-tab_up").css({
        "width": "calc(22px * 0.8)",
        "height": "calc(22px * 0.8)",
      });
      $(".newsTitle, .webNewsTitle").css("font-size","calc(9.6pt * 0.8)");
      $(".display-size, .menuLable div, .message-text").css("font-size", "6.4pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "8.32pt");
      $(".article-list ul li").css("font-size", "6.4pt");
    }
    else if(font_size_flag == 1)
    {
      $(".article-img img").css({
        "width": "80%",
        "height": "22px",
      });
      $('.select_custom').css({"width": "76px"});
      $('.commentRow ul').css('margin-left', '65px');
      $('.commentRow .logoArtInfo').css('min-height', '32px');
       $('.strip').removeClass('smallStrip');
       $('.strip').removeClass('largeStrip');
       $('.strip').addClass('mediumStrip');
      $('.year-arrow').removeClass('arrowSortSmall');
      $('.year-arrow').removeClass('arrowSortLarge');
      $('.el-menu--horizontal>.el-menu-item').css('height', '38px');
      $('.menuParent, .webMenuParent').css('height', '34px');
      $('.toolTipDiv span label').css('line-height', '36px');
      $('.year-arrow').css('line-height', '36px');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', '8pt');
      $(".toolTipDiv span label").css("font-size", "8pt"); 
      $(".selectList").css("font-size", "8pt"); 
       $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "14px",
        "height": "14px",
      });
      $(".display-size > ul > li > span").css('font-size', '9.6pt');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('largeCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('smallCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "22px",
        "height": "22px",
      });
      // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
       "width": "22px",
        "height": "22px",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "22px",
        "height": "22px",
      });
      $(".ico_batch-display_up").css({
        "width": "16.57px",
        "height": "22px",
      });
      $(".ico_another-tab_up").css({
        "width": "22px",
        "height": "22px",
      });
      $(".newsTitle, .webNewsTitle").css("font-size", "9.6pt");
      $(".display-size, .menuLable div, .message-text, .DisplaySize").css("font-size", "8pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "10.4pt");
      $(".article-list ul li").css("font-size", "8pt");
    }
    else
    {
      $(".article-img img").css({
        "width": "calc(80% * 1.5)",
        "height": "calc(22px * 1.5)",
      }); 
      $('.articleLabel').css({
        "width": "85px",
        "display": "inline-table"
      });
      $('.select_custom').css({"width": "108px"});
      $('.ariticle-bottom ul').css('margin-left', '67px');
      $('.commentRow ul').css('margin-left', '85px');
      $('.commentRow .logoArtInfo').css('min-height', '38px');
      $('.strip').addClass('largeStrip');
      $('.strip').removeClass('mediumStrip');
      $('.strip').removeClass('smallStrip');
      $('.year-arrow').removeClass('arrowSortSmall');
      $('.year-arrow').addClass('arrowSortLarge');
      $('.el-menu--horizontal>.el-menu-item').css('height', '45px');
      $('.menuParent, .webMenuParent').css('height', '46px');
      $('.toolTipDiv span label').css('line-height', '47px');
      $('.year-arrow').css('line-height', '54px');
      $('.articleLabel .el-checkbox__inner').removeClass('ArticleSmall');
      $('.articleLabel .el-checkbox__inner').addClass('ArticleLarge');
      $('.articleLabel .el-checkbox__label').css('font-size', 'calc(8pt * 1.5)');
      $(".toolTipDiv span label").css("font-size", "calc(8pt * 1.5)"); 
      $(".selectList").css("font-size", "calc(8pt * 1.5)"); 
       $(".articleLabel .el-checkbox__input, .articleLabel .el-checkbox__input .el-checkbox__inner").css({
        "width": "calc(14px * 1.5)",
        "height": "calc(14px * 1.5)",
      });
      $(".display-size > ul > li > span").css('font-size', 'calc(9.6pt * 1.5)');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner ").addClass('largeCheck');
      $("#newsFontSizeChange .el-checkbox__inner, #newsTabFontSizeChange .el-checkbox__inner, #webFontSizeChange .el-checkbox__inner, #webTabFontSizeChange .el-checkbox__inner").removeClass('smallCheck');
      $(".ico_comment_upSmall, .ico_sort_up, .ico_csv-output_up, .ico_print_up, .ico_pdf_upSmall, .ico_text_upSmall, .ico_print_upSmall, .checkList .el-checkbox__inner, .checkList").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
       // Disable icon style
      $(".ico_pdf_Disable, .ico_article_details_Disable, .ico_text_Disable, .ico_print_Disable").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_article-details_up, .ico_article_details_upSmall").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_batch-display_up").css({
        "width": "calc(16.57px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".ico_another-tab_up").css({
        "width": "calc(22px * 1.5)",
        "height": "calc(22px * 1.5)",
      });
      $(".newsTitle, .webNewsTitle").css("font-size","calc(9.6pt * 1.5)");
      $(".display-size, .menuLable div, .message-text").css("font-size", "12pt");
      $(".article-top, .article_top, .article-top-disable ").css("font-size", "15.6pt");
      $(".article-list ul li").css("font-size", "12pt");
    }
  }
}
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}

label {
  font-size: 8pt;
  padding-left: 6px;
}

.el-checkbox {
  margin-right: 0px !important;
}

.infinite-list-wrapper, .AllWebTabInfiniteWrapper {
    text-align: left;
}
.infinite-list-wrapper .list {
    padding: 0;
    margin: 0;
    list-style: none;
    margin-bottom: 45px;
}

.infinite-list-wrapper .list-item {
    display: flex;
    align-items: left;
    justify-content: left;
    height: 100px;
}

.infinite-list-wrapper .list-item+.list-item {
    margin-top: 10px;
}

.centeralign_css {
  position: relative !important;
  bottom: 27px !important;
  right: 5px !important;            
  width: 100% !important;
  text-align: center !important;
}

.infinite-list-wrapper .listItem:nth-child(2n+2) {
  background-color: #f2f5f8;
}

.articleDiv {
  width: 100%;
}
.articleDiv .el-row {
  display: flex;
}
/* *************    hover focus svg icons        ************* */
.ico_pdf_upSmall, .AllWebTabico_pdf_upSmall {
  background: url("../../assets/image/ico_pdf_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}

.ico_pdf_upSmall, .AllWebTabico_pdf_upSmall:hover {
  background: url("../../assets/image/ico_pdf_over.svg") no-repeat;
}

.ico_pdf_upSmall, .AllWebTabico_pdf_upSmall:focus {
  background: url("../../assets/image/ico_pdf_down.svg") no-repeat;
  outline: none;
}

.ico_article_details_upSmall, .AllWebTabico_article_details_upSmall {
  background: url("../../assets/image/ico_article-details_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}

.ico_article_details_upSmall, .AllWebTabico_article_details_upSmall:hover {
  background: url("../../assets/image/ico_article-details_over.svg") no-repeat;
}

.ico_article_details_upSmall, .AllWebTabico_article_details_upSmall:focus {
  background: url("../../assets/image/ico_article-details_down.svg") no-repeat;
  outline: none;
}

.ico_text_upSmall, .AllWebTabico_text_upSmall {
  background: url("../../assets/image/ico_text_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}
.ico_text_upSmall, .AllWebTabico_text_upSmall:hover {
  background: url("../../assets/image/ico_text_over.svg") no-repeat;
}
.ico_text_upSmall, .AllWebTabico_text_upSmall:focus {
  background: url("../../assets/image/ico_text_down.svg") no-repeat;
  outline: none;
}

.ico_print_upSmall, .AllWebTabico_print_upSmall {
  background: url("../../assets/image/ico_print_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}
.ico_print_upSmall, .AllWebTabico_print_upSmall:hover {
  background: url("../../assets/image/ico_print_over.svg") no-repeat;
}
.ico_print_upSmall, .AllWebTabico_print_upSmall:focus {
  background: url("../../assets/image/ico_print_down.svg") no-repeat;
  outline: none;
}

.ico_comment_upSmall, .AllWebTabico_comment_upSmall {
  background: url("../../assets/image/ico_comment_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  position: relative;
  top: 5px;
}

.commentRow {
  min-height: 26px;
}

#anim > div > div > div > span > section:nth-child(2) > div {
  background-color: var(--grayBackground);
}

.article-img img {
  width: 70px;
  float: left;
  padding-top: 3px;
}

.checkbox-list {
  padding: 8px 0px 8px 7px;
}
.articleNews {
  float: left;
  width: 100%;
}
.articleLabel {
  float: left;
  width: 65px;
}
.articleLabel label:nth-child(2) {
  padding-left: 0px;
  line-height: 35px;
  color: var(--grayDark2);
}
.header-article {
  height: 45px !important;
  display: contents;
}

.el-main {
  overflow: hidden !important;
  padding: 0px !important;
}

.article-main-divider {
  margin: 0px !important;
  background: var(--grayLight2) !important;
}

.article-footer-divider {
  margin: 0px !important;
  background: #a2a4aa !important;
}

.article-top, .WebTabArticleTitleText {
  font-size: 10.4pt;
  font-weight: bold;
  font-family: BIZ UDゴシック;
  padding-right: 0px;
  color: var(--link);
  cursor: pointer;
  display: block;
  margin-top: 9px;
  line-height: 22px;
}

.article-top:focus {
  color: var(--visited);
  outline: none;
}

.article-top:hover {
  color: #660099;
}

.article-top, .WebTabArticleTitleText a{
  font-size: 10.4pt;
  font-weight: bold;
  font-family: BIZ UDゴシック;
  padding-right: 0px;
  color: var(--link);
  cursor: pointer;
  display: block;
  margin-top: 9px;
  line-height: 22px;
  text-decoration: none; 
}

.article-top:focus {
  color: var(--visited);
  outline: none;
}

.article-top:hover {
  color: #660099;
  text-decoration: underline!important;
}

.article-middle {
  padding: 0px;
  margin: 0px auto;
  padding-left: 45px;
}

.el-footer {
  height: auto !important;
  padding-right: 0px;
}

.WebTabArticleList ul {
  padding: 0px;
  margin: 6px auto;
}

.article-list ul li, .WebTabArticleList ul li {
      list-style: inside;
    font-size: 8pt;
    padding-right: 8px;
    color: var(--grayDark);
    cursor: pointer;
        line-height: 1.1;
        cursor: default;
}

.article-right ul {
  padding: 0px;
  margin: 8px auto;
}

.article-right ul li {
  list-style: none;
  float: right;
  padding-left: 12px;
  color: #0097e0;
  padding-top: 5px;
  padding-bottom: 5px;
}

.article-right ul li img {
  width: 15px;
  margin-top: -1px;
}

.message {
  float: right;
  font-size: 20px;
  color: #0097e0;
  line-height: 28px;
  display: block;
  margin-right: 5px;
}

.message img {
  width: 24px;
  margin-left: 15px;
}

.message-text, .WebTabArticleMessageText {
  font-size: 8pt;
  color: var(--grayDark);
  position: relative;
  word-break: break-all;
}

.WebTabArticleMessageText ::v-deep h4 {
  margin: 0px !important;
}
.WebTabArticleMessageText ::v-deep.ql-align-right {
  text-align: right;
  width: auto;
}
.WebTabArticleMessageText ::v-deep.ql-align-left {
  text-align: left;
  width: auto;
}
.WebTabArticleMessageText ::v-deep.ql-align-center {
  text-align: center;
  width: auto;
}
.tooltip-image img {
  height: 90px;
  padding: 5px;
}

.commentRow ul {
  padding: 0px;
  margin: 0px auto;
  margin-left: 65px;
  min-height: 26px;
}

.commentRow ul li {
  float: left;
}

.commentRow ul li:last-child {
  float: right;
}
.ariticle-bottom {
  display: flex;
}
.ariticle-bottom ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
  display: flex;
  width: 100%;
  margin-left: 50px;
}

.ariticle-bottom ul li {
  float: left;
}

.ariticle-bottom ul li:nth-child(1) {
  float: left;
}

.ariticle-bottom ul li:nth-child(2) {
  float: left;
  width: 100%;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}

.article-img {
  width: 108px;
}

.list-first-div {
  width: 60px;
}

.list-first-div div {
  display: inline-block;
}

.WebTabArticleList ul li:first-child {
  padding-left: 0px !important;
}

.articleSpec {
  display: inline-block !important;
  margin-left: 0px !important;
}
.articleSpec li {
  float: left !important;
  padding-top: 10px;
}
.iconUl {
  margin-left: 0px !important;
  float: right;
}
.article-first-child {
  width: 100px;
}
.article-second-child {
  width: calc(100% - 265px);
}
.article-third-child {
  width: 175px;
  position: absolute;
  right: 0;
  top: -5px;
}
.article-right ul li:last-child {
  padding-right: 5px;
}

.article-right ul li:first-child {
  padding-left: 0px;
}
.articleSpec li .articleSpan {
    margin-left: -6px;
}
#articleParentDiv >>> .el-checkbox__label {
  font-size: 8pt;
}

.ico_another-tab_up {
  background: url("../../assets/image/ico_another-tab_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}

.ico_another-tab_up:hover {
  background: url("../../assets/image/ico_another-tab_up.svg") no-repeat;
}

.ico_another-tab_up:focus {
  background: url("../../assets/image/ico_another-tab_up.svg") no-repeat;
  outline: none;
}

.ico_another_disable-tab_up {
  background: url("../../assets/image/ico_another-tab_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  opacity: 0.3;
}
</style>
